import FreelancerOnboardingShell from "./FreelancerOnboardingShell";

const FreelancerOnboardingFlow = () => {
  return <FreelancerOnboardingShell />;
};

export default FreelancerOnboardingFlow;
